import { render, staticRenderFns } from "./NodeDetail.vue?vue&type=template&id=90b85942"
import script from "./NodeDetail.vue?vue&type=script&lang=js"
export * from "./NodeDetail.vue?vue&type=script&lang=js"
import style0 from "./NodeDetail.vue?vue&type=style&index=0&id=90b85942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports